// test1768
(1768 && 0);
